import axios from 'axios';

console.log(process.env.NODE_ENV);

const apiClient = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default apiClient;